import PageLoader from '../common/PageLoader'
import Footer from '../layout/Footer'
import Header from '../layout/Header'
import ScrollToTop from '../layout/ScrollToTop'

function MainLayout({ children }) {
  return (
    <>
      <PageLoader />
      <ScrollToTop />
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  )
}

export default MainLayout
